import { Type } from '../services/types'

const units = new Map()

units.set(Type.CO2, 'ppm')
units.set(Type.Temperature, '℃')
units.set(Type.Humidity, '%')

export default units
